
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as billVh8np08wwPMeta } from "/vercel/path0/pages/bill.vue?macro=true";
import { default as downloadhJvQzgwFZcMeta } from "/vercel/path0/pages/download.vue?macro=true";
import { default as enter_45emailozPgmq3QxWMeta } from "/vercel/path0/pages/enter-email.vue?macro=true";
import { default as final_45pageIWJVhkTa5FMeta } from "/vercel/path0/pages/final-page.vue?macro=true";
import { default as landingIrNCINQjz2Meta } from "/vercel/path0/pages/landing.vue?macro=true";
import { default as bladdertbjSO4VrMVMeta } from "/vercel/path0/pages/quiz/[id]/bladder.vue?macro=true";
import { default as bodykOcSvXQBWWMeta } from "/vercel/path0/pages/quiz/[id]/body.vue?macro=true";
import { default as graphsPhVSzKI7uMeta } from "/vercel/path0/pages/quiz/[id]/graph.vue?macro=true";
import { default as height7fuoI2eB6KMeta } from "/vercel/path0/pages/quiz/[id]/height.vue?macro=true";
import { default as libidornaRetRnDTMeta } from "/vercel/path0/pages/quiz/[id]/libido.vue?macro=true";
import { default as nameYOtv0gHWcPMeta } from "/vercel/path0/pages/quiz/[id]/name.vue?macro=true";
import { default as orgasm8WzAHeCMhIMeta } from "/vercel/path0/pages/quiz/[id]/orgasm.vue?macro=true";
import { default as pain1Xe0t7VkLkMeta } from "/vercel/path0/pages/quiz/[id]/pain.vue?macro=true";
import { default as PFqo4FLEHg6xMeta } from "/vercel/path0/pages/quiz/[id]/PF.vue?macro=true";
import { default as questioniDzzxauEwhMeta } from "/vercel/path0/pages/quiz/[id]/question.vue?macro=true";
import { default as rateZyiCc25rCRMeta } from "/vercel/path0/pages/quiz/[id]/rate.vue?macro=true";
import { default as weightNEdXs10vS5Meta } from "/vercel/path0/pages/quiz/[id]/weight.vue?macro=true";
import { default as womenhi7nxgyTx6Meta } from "/vercel/path0/pages/quiz/[id]/women.vue?macro=true";
import { default as analyzing_45answers5yivgXoqssMeta } from "/vercel/path0/pages/quiz/analyzing-answers.vue?macro=true";
import { default as cardHXJrPHfaBEMeta } from "/vercel/path0/pages/quiz/card.vue?macro=true";
import { default as creating_45planOushZ54F7sMeta } from "/vercel/path0/pages/quiz/creating-plan.vue?macro=true";
import { default as final_45adjustment5kuQrijrFPMeta } from "/vercel/path0/pages/quiz/final-adjustment.vue?macro=true";
import { default as plan_45readyXyjsAW74SrMeta } from "/vercel/path0/pages/quiz/plan-ready.vue?macro=true";
import { default as verify_45emailTib6n1igWMMeta } from "/vercel/path0/pages/verify-email.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "bill___en",
    path: "/en/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___es",
    path: "/es/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___es-mx",
    path: "/es-mx/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___pt",
    path: "/pt/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___pt-br",
    path: "/pt-br/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___de",
    path: "/de/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___fr",
    path: "/fr/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___it",
    path: "/it/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "bill___keys-test",
    path: "/keys-test/bill",
    component: () => import("/vercel/path0/pages/bill.vue")
  },
  {
    name: "download___en",
    path: "/en/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___es",
    path: "/es/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___es-mx",
    path: "/es-mx/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___pt",
    path: "/pt/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___pt-br",
    path: "/pt-br/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___de",
    path: "/de/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___fr",
    path: "/fr/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___it",
    path: "/it/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "download___keys-test",
    path: "/keys-test/download",
    meta: downloadhJvQzgwFZcMeta || {},
    component: () => import("/vercel/path0/pages/download.vue")
  },
  {
    name: "enter-email___en",
    path: "/en/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___es",
    path: "/es/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___es-mx",
    path: "/es-mx/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___pt",
    path: "/pt/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___pt-br",
    path: "/pt-br/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___de",
    path: "/de/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___fr",
    path: "/fr/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___it",
    path: "/it/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "enter-email___keys-test",
    path: "/keys-test/enter-email",
    meta: enter_45emailozPgmq3QxWMeta || {},
    component: () => import("/vercel/path0/pages/enter-email.vue")
  },
  {
    name: "final-page___en",
    path: "/en/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___es",
    path: "/es/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___es-mx",
    path: "/es-mx/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___pt",
    path: "/pt/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___pt-br",
    path: "/pt-br/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___de",
    path: "/de/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___fr",
    path: "/fr/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___it",
    path: "/it/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "final-page___keys-test",
    path: "/keys-test/final-page",
    component: () => import("/vercel/path0/pages/final-page.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es",
    path: "/es",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___es-mx",
    path: "/es-mx",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___pt",
    path: "/pt",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___pt-br",
    path: "/pt-br",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___de",
    path: "/de",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___fr",
    path: "/fr",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___it",
    path: "/it",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "index___keys-test",
    path: "/keys-test",
    meta: indexe9Brt5DfdhMeta || {},
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "landing___en",
    path: "/en/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___es",
    path: "/es/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___es-mx",
    path: "/es-mx/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___pt",
    path: "/pt/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___pt-br",
    path: "/pt-br/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___de",
    path: "/de/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___fr",
    path: "/fr/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___it",
    path: "/it/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "landing___keys-test",
    path: "/keys-test/landing",
    meta: landingIrNCINQjz2Meta || {},
    component: () => import("/vercel/path0/pages/landing.vue")
  },
  {
    name: "quiz-id-bladder___en",
    path: "/en/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___es",
    path: "/es/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___es-mx",
    path: "/es-mx/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___pt",
    path: "/pt/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___pt-br",
    path: "/pt-br/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___de",
    path: "/de/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___fr",
    path: "/fr/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___it",
    path: "/it/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-bladder___keys-test",
    path: "/keys-test/quiz/:id()/bladder",
    meta: bladdertbjSO4VrMVMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/bladder.vue")
  },
  {
    name: "quiz-id-body___en",
    path: "/en/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___es",
    path: "/es/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___es-mx",
    path: "/es-mx/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___pt",
    path: "/pt/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___pt-br",
    path: "/pt-br/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___de",
    path: "/de/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___fr",
    path: "/fr/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___it",
    path: "/it/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-body___keys-test",
    path: "/keys-test/quiz/:id()/body",
    meta: bodykOcSvXQBWWMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/body.vue")
  },
  {
    name: "quiz-id-graph___en",
    path: "/en/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___es",
    path: "/es/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___es-mx",
    path: "/es-mx/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___pt",
    path: "/pt/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___pt-br",
    path: "/pt-br/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___de",
    path: "/de/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___fr",
    path: "/fr/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___it",
    path: "/it/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-graph___keys-test",
    path: "/keys-test/quiz/:id()/graph",
    component: () => import("/vercel/path0/pages/quiz/[id]/graph.vue")
  },
  {
    name: "quiz-id-height___en",
    path: "/en/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___es",
    path: "/es/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___es-mx",
    path: "/es-mx/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___pt",
    path: "/pt/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___pt-br",
    path: "/pt-br/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___de",
    path: "/de/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___fr",
    path: "/fr/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___it",
    path: "/it/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-height___keys-test",
    path: "/keys-test/quiz/:id()/height",
    meta: height7fuoI2eB6KMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/height.vue")
  },
  {
    name: "quiz-id-libido___en",
    path: "/en/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___es",
    path: "/es/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___es-mx",
    path: "/es-mx/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___pt",
    path: "/pt/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___pt-br",
    path: "/pt-br/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___de",
    path: "/de/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___fr",
    path: "/fr/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___it",
    path: "/it/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-libido___keys-test",
    path: "/keys-test/quiz/:id()/libido",
    meta: libidornaRetRnDTMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/libido.vue")
  },
  {
    name: "quiz-id-name___en",
    path: "/en/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___es",
    path: "/es/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___es-mx",
    path: "/es-mx/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___pt",
    path: "/pt/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___pt-br",
    path: "/pt-br/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___de",
    path: "/de/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___fr",
    path: "/fr/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___it",
    path: "/it/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-name___keys-test",
    path: "/keys-test/quiz/:id()/name",
    meta: nameYOtv0gHWcPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/name.vue")
  },
  {
    name: "quiz-id-orgasm___en",
    path: "/en/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___es",
    path: "/es/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___es-mx",
    path: "/es-mx/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___pt",
    path: "/pt/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___pt-br",
    path: "/pt-br/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___de",
    path: "/de/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___fr",
    path: "/fr/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___it",
    path: "/it/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-orgasm___keys-test",
    path: "/keys-test/quiz/:id()/orgasm",
    meta: orgasm8WzAHeCMhIMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/orgasm.vue")
  },
  {
    name: "quiz-id-pain___en",
    path: "/en/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___es",
    path: "/es/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___es-mx",
    path: "/es-mx/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___pt",
    path: "/pt/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___pt-br",
    path: "/pt-br/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___de",
    path: "/de/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___fr",
    path: "/fr/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___it",
    path: "/it/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-pain___keys-test",
    path: "/keys-test/quiz/:id()/pain",
    meta: pain1Xe0t7VkLkMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/pain.vue")
  },
  {
    name: "quiz-id-PF___en",
    path: "/en/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___es",
    path: "/es/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___es-mx",
    path: "/es-mx/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___pt",
    path: "/pt/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___pt-br",
    path: "/pt-br/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___de",
    path: "/de/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___fr",
    path: "/fr/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___it",
    path: "/it/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-PF___keys-test",
    path: "/keys-test/quiz/:id()/PF",
    meta: PFqo4FLEHg6xMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/PF.vue")
  },
  {
    name: "quiz-id-question___en",
    path: "/en/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___es",
    path: "/es/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___es-mx",
    path: "/es-mx/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___pt",
    path: "/pt/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___pt-br",
    path: "/pt-br/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___de",
    path: "/de/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___fr",
    path: "/fr/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___it",
    path: "/it/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-question___keys-test",
    path: "/keys-test/quiz/:id()/question",
    meta: questioniDzzxauEwhMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/question.vue")
  },
  {
    name: "quiz-id-rate___en",
    path: "/en/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___es",
    path: "/es/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___es-mx",
    path: "/es-mx/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___pt",
    path: "/pt/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___pt-br",
    path: "/pt-br/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___de",
    path: "/de/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___fr",
    path: "/fr/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___it",
    path: "/it/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-rate___keys-test",
    path: "/keys-test/quiz/:id()/rate",
    meta: rateZyiCc25rCRMeta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/rate.vue")
  },
  {
    name: "quiz-id-weight___en",
    path: "/en/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___es",
    path: "/es/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___es-mx",
    path: "/es-mx/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___pt",
    path: "/pt/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___pt-br",
    path: "/pt-br/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___de",
    path: "/de/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___fr",
    path: "/fr/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___it",
    path: "/it/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-weight___keys-test",
    path: "/keys-test/quiz/:id()/weight",
    meta: weightNEdXs10vS5Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/weight.vue")
  },
  {
    name: "quiz-id-women___en",
    path: "/en/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___es",
    path: "/es/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___es-mx",
    path: "/es-mx/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___pt",
    path: "/pt/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___pt-br",
    path: "/pt-br/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___de",
    path: "/de/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___fr",
    path: "/fr/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___it",
    path: "/it/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-id-women___keys-test",
    path: "/keys-test/quiz/:id()/women",
    meta: womenhi7nxgyTx6Meta || {},
    component: () => import("/vercel/path0/pages/quiz/[id]/women.vue")
  },
  {
    name: "quiz-analyzing-answers___en",
    path: "/en/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___es",
    path: "/es/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___es-mx",
    path: "/es-mx/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___pt",
    path: "/pt/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___pt-br",
    path: "/pt-br/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___de",
    path: "/de/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___fr",
    path: "/fr/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___it",
    path: "/it/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-analyzing-answers___keys-test",
    path: "/keys-test/quiz/analyzing-answers",
    component: () => import("/vercel/path0/pages/quiz/analyzing-answers.vue")
  },
  {
    name: "quiz-card___en",
    path: "/en/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___es",
    path: "/es/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___es-mx",
    path: "/es-mx/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___pt",
    path: "/pt/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___pt-br",
    path: "/pt-br/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___de",
    path: "/de/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___fr",
    path: "/fr/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___it",
    path: "/it/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-card___keys-test",
    path: "/keys-test/quiz/card",
    component: () => import("/vercel/path0/pages/quiz/card.vue")
  },
  {
    name: "quiz-creating-plan___en",
    path: "/en/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___es",
    path: "/es/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___es-mx",
    path: "/es-mx/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___pt",
    path: "/pt/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___pt-br",
    path: "/pt-br/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___de",
    path: "/de/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___fr",
    path: "/fr/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___it",
    path: "/it/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-creating-plan___keys-test",
    path: "/keys-test/quiz/creating-plan",
    component: () => import("/vercel/path0/pages/quiz/creating-plan.vue")
  },
  {
    name: "quiz-final-adjustment___en",
    path: "/en/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___es",
    path: "/es/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___es-mx",
    path: "/es-mx/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___pt",
    path: "/pt/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___pt-br",
    path: "/pt-br/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___de",
    path: "/de/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___fr",
    path: "/fr/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___it",
    path: "/it/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-final-adjustment___keys-test",
    path: "/keys-test/quiz/final-adjustment",
    meta: final_45adjustment5kuQrijrFPMeta || {},
    component: () => import("/vercel/path0/pages/quiz/final-adjustment.vue")
  },
  {
    name: "quiz-plan-ready___en",
    path: "/en/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___es",
    path: "/es/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___es-mx",
    path: "/es-mx/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___pt",
    path: "/pt/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___pt-br",
    path: "/pt-br/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___de",
    path: "/de/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___fr",
    path: "/fr/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___it",
    path: "/it/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "quiz-plan-ready___keys-test",
    path: "/keys-test/quiz/plan-ready",
    meta: plan_45readyXyjsAW74SrMeta || {},
    component: () => import("/vercel/path0/pages/quiz/plan-ready.vue")
  },
  {
    name: "verify-email___en",
    path: "/en/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___es",
    path: "/es/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___es-mx",
    path: "/es-mx/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt",
    path: "/pt/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___pt-br",
    path: "/pt-br/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___de",
    path: "/de/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___fr",
    path: "/fr/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___it",
    path: "/it/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  },
  {
    name: "verify-email___keys-test",
    path: "/keys-test/verify-email",
    component: () => import("/vercel/path0/pages/verify-email.vue")
  }
]